import { useContext, useEffect } from 'react';
import { EventEmitterContext } from '@prodelio/event-system/EventEmitterContext';

export const useEventDispatch = () => {
  const { dispatchEvent } = useContext(EventEmitterContext);

  return dispatchEvent;
};
